import React from 'react';
import { observer } from 'mobx-react';
import { RuleEngineController } from './ruleEngine.Controller';
import { CQMasterDataStore } from '../../../store/cq-master-data.store';

export const AppliedRulesListContainer = observer((props: { toggleModalVisibility: Function, selectedTemplateName: string }) => {
    const fieldObj: any = CQMasterDataStore.Details.selectedFieldDetailsObject;
    const ruleEngineController = new RuleEngineController();
    const selectedFieldRules = CQMasterDataStore.RuleElements.FieldRuleElement[fieldObj.fullName];
    const isNbaInputRule = CQMasterDataStore.OutputConfig.cqNBA.inputRules[fieldObj.fullName];
    const className:string = fieldObj.isComponentEventRule?'slds-button slds-button_brand':'slds-col slds-size_1-of-3 slds-button slds-button_brand';
    return (
        <div className="form-rules-content slds-m-bottom_x-small">
            <h2 className="slds-text-heading_small slds-m-bottom_small">{fieldObj.isComponentEventRule ? 'Component Events' : 'Form Rule'}</h2>
            <ul className="slds-listbox" role="listbox" aria-label="Selected Options:" aria-orientation="horizontal">
                {selectedFieldRules &&
                    Object.keys(selectedFieldRules).map((rule: string, index: number) => {
                        //hide display for both 'PicklistValueSource' or 'UITypeSource' rule
                        if(rule === 'PicklistValueSource' || rule === 'UITypeValueSource' || rule === 'LookupFilter'){
                            return null;
                        } else {
                            return (
                            <li key={index} className="slds-listbox-item" role="presentation">
                            <span className="slds-pill" role="option" aria-selected="true">
                                <span className="slds-pill__label" >{rule}</span>
                                <button className="slds-button" onClick={() => { props.toggleModalVisibility(fieldObj.fullName, rule, selectedFieldRules[rule]); }}>
                                    <span className="slds-icon_container" title="Edit">
                                        <i className="cq-icon-edit"></i>
                                    </span>
                                </button>
                            </span>
                            <button onClick={() => { ruleEngineController.deleteAppliedRule(fieldObj.fullName, rule, props.selectedTemplateName); }}
                                className="slds-button slds-text-color_destructive">
                                <span className="slds-icon_container" title="Delete">
                                    <i className="cq-icon-delete cq-2x"></i>
                                </span>
                            </button>
                        </li>
                        );
                        }
                    })
                }
                {!isNbaInputRule &&
                <button disabled={!(fieldObj.label)} className={className}
                    onClick={() => { props.toggleModalVisibility(); }}>
                    {fieldObj.isComponentEventRule ? 'Add Event Rule' : 'Add Rule'}</button>}
            </ul>
        </div>
    );
});
